import _ from 'lodash';
import { realTr } from '@lsoft/shared/nextjs/translate/realTr';

export const getTranslation = (tr, locale, locales) => {
	const activeLanguage = _.isNil(locale) ? 'EN' : locale.toUpperCase();
	return realTr(tr, activeLanguage);
};
